import get from 'lodash/get';

export default function isEftFieldDisabled(fieldKey, formData) {
  if (get(formData, 'paymentOption', false)) {
    switch (fieldKey) {
      case 'accountNumber':
      case 'accountType':
      case 'institutionNumber':
      case 'branchNumber':
        return true;

      default:
        return false;
    }
  }

  return false;
}
